// extracted by mini-css-extract-plugin
export var bottom = "VerticalTitle-module--bottom--8MOyb";
export var containerFix = "VerticalTitle-module--containerFix--3C9Ez";
export var title = "VerticalTitle-module--title--2TUym";
export var top = "VerticalTitle-module--top--V-u8L";